<template>
    <v-card>
        <v-card-title>
            <div class="mr-3">{{$t('event.general')}}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddGeneral">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="tableGeneral"
                      :loading="isGeneralPending"
                      @pagination="currentPagination"
                      >
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.order="{value}">
                {{value}}
            </template>
            <template v-slot:item.answer="{value}">
                <froalaView v-model="value" class="popup-preview"></froalaView>
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                       @click="initEditGeneral(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                       @click="deleteGeneral(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="editGeneralDialogShown"
                  max-width="600px"
                  persistent
                  scrollable
                  :retain-focus="false"
                  >
            <v-card>
                <v-card-title>
                    {{$t('event.general')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditGeneralFormValid">
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field outlined
                                                  :label="$t('event_general.category')"
                                                  :placeholder="$t('event_general.category')"
                                                  v-model="editingGeneral.category"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_general.title') + ' EN'"
                                        :placeholder="$t('event_general.title') + ' EN'"
                                        v-model="editingGeneral.title"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_general.content')}} EN</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingGeneral.content"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_general.title') + ' TC'"
                                        :placeholder="$t('event_general.title') + ' TC'"
                                        v-model="editingGeneral.title_tc"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_general.content')}} TC</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingGeneral.content_tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field outlined
                                        :label="$t('event_general.title') + ' SC'"
                                        :placeholder="$t('event_general.title') + ' SC'"
                                        v-model="editingGeneral.title_sc"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_general.content')}} SC</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingGeneral.content_sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmSaveItemDialogShown = true"
                           :disabled="!isEditGeneralFormValid">{{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <PopupAlert 
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditGeneralItem"
            :onNo="function() {confirmCancelItemDialogShown=false;}"
            ></PopupAlert>
        <PopupAlert 
            v-model="confirmSaveItemDialogShown"
            title="Confirm"
            message="Do you wish to confirm to save your general?"
            :onYes="saveGeneral"
            :onNo="function() {confirmSaveItemDialogShown=false;}"
            ></PopupAlert>
    </v-card>
</template>

<style scoped>
    .button-spacer {
        width:10px;
    }
</style>

<script>
    import {computed, ref, onMounted} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import {cloneDeep} from "lodash";
    import PopupAlert from "../../components/PopupAlert";
    import Sortable from "sortablejs";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventGeneral',
        components:{PopupAlert},
        setup(props, {root}) {
            const {EventGeneral} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const eventId = computed(() => root.$route.params.eventId);

            const generalParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                        $sort: {order: 1},
                    }
                }
            });
            const {items: generalItems, isPending: isGeneralPending} = useFind({
                model: EventGeneral,
                params: generalParams,
            });
            // Data Table
            const headers = ref([
                {text: '', value: 'scroller', width: 80},
                {text: root.$t('event_general.order'), value: 'order'},
                {text: root.$t('event_general.category'), value: 'category'},
                {text: root.$t('event_general.title'), value: 'title'},
                {text: root.$t('event_general.content'), value: 'content', width: '300px'},
                {text: '', value: 'actions'},
            ]);

            // Order
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderGeneral = ref([]);
            const overlay = ref(false);

            // Add / Edit General
            const editGeneralDialogShown = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const confirmSaveItemDialogShown = ref(false);
            const isEditGeneralFormValid = ref(false);
            const editingGeneral = ref(new EventGeneral({eventId: eventId.value}));
            const initAddGeneral = function () {
                editingGeneral.value = new EventGeneral({eventId: eventId.value});
                editingGeneral.value.order = generalItems.value.length + 1;
                editGeneralDialogShown.value = true;
            };
            const initEditGeneral = function (general) {
                editingGeneral.value = cloneDeep(general);
                editGeneralDialogShown.value = true;
            };
            const deleteGeneral = function (general) {
                if (confirm(root.$t('event_general.confirm_delete'))) {
                    general.remove();
                }
            };
            const saveGeneral = async function () {
                editingGeneral.value.save().then(() => {
                    EventGeneral.get(editingGeneral.value.id);
                    editGeneralDialogShown.value = false;
                    confirmSaveItemDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('event_general.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const cancelEditGeneralItem = function(){
                editGeneralDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }

            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderGeneral.value = cloneDeep(sortedGeneral.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                console.log("editOrderGeneral:",editOrderGeneral.value)
                for(let i=0;i<editOrderGeneral.value.length;i++){
                    await editOrderGeneral.value[i].save().then(()=>{
                        EventGeneral.get(editOrderGeneral.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortGeneral = function(sortGeneral){
                if(sortGeneral.length<2){
                    return sortGeneral
                }

                const chosenIndex = sortGeneral.length - 1
                const chosen  = sortGeneral[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortGeneral[i].order
                    temp < chosen.order ? a.push(sortGeneral[i]) : b.push(sortGeneral[i])
                }
                const output = [...quickSortGeneral(a),chosen,...quickSortGeneral(b)]
                return output
            }

            const sortedGeneral = computed(()=>{
                return quickSortGeneral(generalItems.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderGeneral.value.splice(oldIndex,1)[0];
                            editOrderGeneral.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderGeneral.value.length;i++){
                                editOrderGeneral.value[i].order = i+1
                            }
                            editOrderGeneral.value = quickSortGeneral(editOrderGeneral.value);
                        }
                    }
                )
            });

            const tableGeneral = computed(()=>{
                return isEditOrderMode.value?editOrderGeneral.value:sortedGeneral.value
            })

            return {
                generalItems,
                isGeneralPending,

                headers,
                tableGeneral,

                editGeneralDialogShown,
                confirmCancelItemDialogShown,
                confirmSaveItemDialogShown,
                initAddGeneral,
                initEditGeneral,
                deleteGeneral,
                isEditGeneralFormValid,
                editingGeneral,
                saveGeneral,
                cancelEditGeneralItem,

                DateTime,
                getFileUrl: root.$getFileURL,

                previewHtmlContentOption,
                currentPagination,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                isEditOrderMode,
                overlay,

                showEditor,
                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
